import { VStack } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorNewCoursesPromoVideoUrl } from '../../../../../configuration';
import { closeModal } from '../../../modal-manager';
import { VideoPlayer } from '../../../video-player/video-player';
import { NewCoursesPromoVideoWrapper } from './new-courses-promo-video-modal.styled';

export function NewCoursesVideoModal () {
    const dispatch = useDispatch();
    const newCoursesPromoVideoUrl = useSelectorNewCoursesPromoVideoUrl();

    return (
        <NewCoursesPromoVideoWrapper>
            <VStack
                spacing={0}
                align={'center'}
                textAlign={'center'}
                h={'602px'}
                w={'993px'}
                mb={0}
            >
                <VideoPlayer
                    onClose={() => dispatch(closeModal())}
                    src={newCoursesPromoVideoUrl}
                    title={'New Courses'}
                />
            </VStack>
        </NewCoursesPromoVideoWrapper>
    );
}

